export const ONLINE_TEST = 'OnlineTest';
export const DISTANCE_TRAINING = 'DistanceTraining';
export const SCORM_TEST = 'ScormTest';
export const LIBRARY_OBJ = 'LibraryObj';
export const LIBRARY_OBJ_BOOK = 'LibraryObjBook';
export const LIBRARY_OBJ_DOC = 'LibraryObjDoc';
